@import '~style-sheet-helpers/core.less';
@import '../component.module.less';

.input-label {
  .input-base-style();
  position: relative;
  grid-column: col-start / span 1;
  padding-right: 15px;
  min-width: 85px;

  &.error {
    color: @error-color-text;
  }
  &.disabled {
    opacity: 0.5;
  }
}

.required-label {
  color: @error-color-text;
  position: absolute;
  top: -10px;
  padding-left: 2px;
  font-size: 10px;
}
